module.exports = __webpack_public_path__ + "img/DocReRouteDemo.a170541c.gif";